export interface ChatInputInterface {
  iconClass: string;
  buttonClass?: string;
  type: 'SEND' | 'VOICE_START' | 'CHAT_STOP' | 'NONE' | 'VOICE_PROGRESS';
  chatType: 'VOICE' | 'INPUT';
  isDisabled: boolean;
}

export const LUKA_VOICE_INPUT: ChatInputInterface = {
  iconClass: 'fa-regular fa-microphone text-white',
  buttonClass:'button-primary-gradient button-medium-icon button-circle border-none res-btn',
  type: 'VOICE_START',
  chatType: 'VOICE',
  isDisabled: false
};

export const LUKA_VOICE_PROGRESS: ChatInputInterface = {
  iconClass: 'fa-regular fa-square text-white',
  buttonClass:'bg-error button-medium-icon button-circle res-btn',
  type: 'VOICE_PROGRESS',
  chatType: 'VOICE',
  isDisabled: false
};

export const LUKA_VOICE_SEND: ChatInputInterface = {
  iconClass: 'fa-regular fa-paper-plane-top text-white',
  buttonClass:'button-primary-gradient button-medium-icon button-circle res-btn',
  type: 'SEND',
  chatType: 'VOICE',
  isDisabled: false
};

export const LUKA_VOICE_SEND_INPUT: ChatInputInterface = {
  iconClass: 'fa-regular fa-paper-plane-top text-white',
  buttonClass:'button-primary-gradient button-medium-icon button-circle res-btn',
  type: 'SEND',
  chatType: 'INPUT',
  isDisabled: false
};
